import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  LogarithmicScale,
  PointElement,
  Title,
  Tooltip
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'

import { registerChartThemeSync } from '@web/entities/chart/lib/chart-theme-sync'
import { resolveThemeColor } from '@web/shared/utils/resolve-theme-color.util'

ChartJS.register(
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  LogarithmicScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
  annotationPlugin,
  ArcElement
)

registerChartThemeSync(() => {
  ChartJS.defaults.color = resolveThemeColor('#666', '--color-text')
  ChartJS.defaults.borderColor = resolveThemeColor(
    'rgba(0, 0, 0, 0.1)',
    '--color-border'
  )
})
